export const ServiceReportsActionTypes = {
    SET_COMPLETED_REPORTS_FOR_ALL_PANELS : 'SET_COMPLETED_REPORTS_FOR_ALL_PANELS',
}